export default __webpack_public_path__ + "static/media/home-combopkgicon.39aff529.png";